import React, { useEffect, useState } from "react";
import { PageTitle } from "../../ui/PageTitle";
import rRais from "../subsidiaries/assets/Kamolov-1M.jpg";

import { FiPhone } from "react-icons/fi";
import { FaRegCalendarCheck } from "react-icons/fa";
import "../leaders/assets/rahbariyat.scss";
import { Image } from 'antd';
import logo from './assets/logo.gif'
import { FaLocationDot } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import http from "../../ui/Services";
import { MdLanguage } from "react-icons/md";
import { urlPer } from "../../../host";
//@ts-ignore
function Leaders() {
  const {t} = useTranslation();
  const [loader, setLoader] = useState(true)
  const [data, setData] = useState<any>(null)
  const loaderT=()=>{
     
  }
  useEffect(()=>{
    http.get<any>(`GetApi/GetRegionContacts`)
        
    .then((res) => {  setTimeout(()=>{
      var b=[]
      b.push(res.data.filter((data: any) => data.regionId === 1))
      
      b.push(res.data.filter((data:any) => data.regionId === 2))
     
      b.push(res.data.filter((data:any) => data.regionId === 3))
     
      b.push(res.data.filter((data:any) => data.regionId === 4))
     
      b.push(res.data.filter((data:any) => data.regionId === 5))
     
      b.push(res.data.filter((data:any) => data.regionId === 6))
     
      b.push(res.data.filter((data:any) => data.regionId === 7))
      
      b.push(res.data.filter((data:any) => data.regionId === 8))
     
      b.push(res.data.filter((data:any) => data.regionId === 9))
     
      b.push(res.data.filter((data:any) => data.regionId === 10))
      
      b.push(res.data.filter((data:any) => data.regionId === 11))
     
      b.push(res.data.filter((data:any) => data.regionId === 12))
     
      b.push(res.data.filter((data:any) => data.regionId === 13))
     
      b.push(res.data.filter((data:any) => data.regionId === 14))
      console.log(b)
      setData(b);
      setLoader(false)
  }, 0) })
    .catch(e => console.log(e))
  },[])
  return (
    <Image.PreviewGroup>
    <div className="rahbariyat" onLoad={()=>{loaderT()}}>
    {loader?<div className="loaderG">
    <div className="befG">
<img src={logo} alt="..."/>
</div>

</div>
:''}
      <div className="container">
      <PageTitle title={t('hududiy_kengashlar')} />
        <div className="rahbariyat-info">
        
        {data!==null?data.map((item:any, index:any)=>{
          return(
            <div className="rahbariyat-list">
              
             <div className="content-wrapper">
             <div className="rahbariyat-list-text" style={{display:"flex", padding:'0px', alignItems:'flex-start', justifyContent:'center'}}> 
              <Image className="img1" src={`${urlPer}/${item[0].photo}`} alt="img" />
              </div>
              <div className="rahbariyat-list-text">
                <p  className="rahbariyat-list-text-position">
                  <b>
                              {t('check')?item[0].regionPresident:item[0].regionPresidentRu}
                </b></p>
  
                <p  className="rahbariyat-list-text-name">
                {t('check')?item[0].regionName:item[0].regionNameRu}
                </p>
                <div className="icons" style={{marginTop:'-10px'}}>
                  <FaRegCalendarCheck  className="icon"  size="1.5rem" color="#244BA4" cursor="pointer"/>
                  <p  style={{position:'relative', top:'-14px'}}>{t('check')?item[0].openDaysUz:item[0].openDaysRu}</p>
                </div>
                <div className="icons">
                  <FiPhone className="icon"  size="1.5rem" color="#244BA4" cursor="pointer"/>
                  <p  style={{position:'relative', top:'-14px'}}><a href={`tel: ${item[0].phoneNumber}`}>{item[0].phoneNumber}</a></p>
                </div>
                <div className="web" style={{height:'40px'}}>
                <MdLanguage className="icon" size="1.5rem" color="#244BA4" cursor="pointer"/>
                <p    style={{position:'relative', top:'-14px'}}><a target="_blank" href={`https://${item[0].webSite}`}>{item[0].webSite}</a></p>
              </div>
              <div className="icons" style={{marginTop:'5px'}}>
                <FaLocationDot className="icon" size="1.5rem" color="#244BA4" cursor="pointer"/>
                <p style={{position:'relative', top:'-14px'}}>{t("lang")==='uz'?item[0].regionAdress:item[0].regionAdressRu}</p>
              </div>
              </div>
              </div> 
            </div>
          )
        }):''}
        
        
        </div>
      </div>
    </div>
    </Image.PreviewGroup>
  );
}

export default Leaders;
